import { persistCombineReducers } from 'redux-persist';
import localforage from 'localforage';

import routeReducer from './atom/route/reducer';
import domainReducer from './atom/domain/reducer';

const rootReducer = persistCombineReducers(
    {
        blacklist: ['route'],
        key: 'sustain-client',
        version: 1,
        storage: localforage,
    },
    {
        // TODO: remove cast after latest update
        route: routeReducer as any,
        domain: domainReducer as any,
    },
);

export default rootReducer;
